import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import AdminSessionIndicator from '../admin/AdminSessionIndicator';
import TestClockTimeIndicator from '../shared/TestClockTimeIndicator';
import ReadOnlyBanner from '../common/ReadOnlyBanner';
import DevEnvironmentBanner from '../common/DevEnvironmentBanner';
import { useAuth } from '../../contexts/AuthContext';

const MainLayout = ({ children }) => {
  const location = useLocation();
  const { user, loading, verifyToken } = useAuth();
  const isFirstRender = useRef(true);

  // Verify token on route changes (skip first render since AuthContext handles that)
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    verifyToken();
  }, [location.pathname]);

  return (
    <div className="dashboard-layout flex flex-col min-h-screen bg-secondary transition-colors duration-200">
      {/* Skip link for keyboard navigation (WCAG 2.4.1) */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-0 focus:left-0 focus:z-[100] focus:bg-blue-600 focus:text-white focus:p-4 focus:font-semibold"
      >
        Skip to main content
      </a>
      {!loading && user && (
        <TestClockTimeIndicator userEmail={user.email} userId={user.id} />
      )}
      <AdminSessionIndicator />
      {/* Show dev environment warning for dev users on production (jetogo.com only) */}
      {!loading && user?.origin_environment === 'dev' && (
        <DevEnvironmentBanner />
      )}
      {/* Show suspension banner for suspended users */}
      {!loading && user?.is_suspended && (
        <ReadOnlyBanner reason={user.suspension_info?.reason} />
      )}
      <Navbar />
      <main id="main-content" tabIndex={-1} className="max-w-[95vw] sm:max-w-[875px] w-full mx-auto !px-0 sm:!px-4 pt-4 pb-16 sm:py-6 flex-grow focus:outline-none">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout;